import React, { useMemo, useState, useEffect } from "react"
import moment from "moment"
 import { useSelector, useDispatch } from "react-redux"
import {
  Alert,
  CardBody,
  Card,
  Row,
  Col, 
  Modal,
  UncontrolledTooltip,
  Button,
  Container,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

//import components
import TableContainer from "components/Common/TableContainer" 
import {
  fetchVenue,
  resetVenue,
  editUser,
  deleteVenue,
   updateVenueStatus,
} from "../../../../toolkitStore/ticketMSlice/TicketVenueSlice"

function VenueTicketList(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  //Delete
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [delete_data, SetDelete_data] = useState()
  const event_id_c = JSON.parse(localStorage.getItem("event_id"))
 
  const { TicketVenueList, TicketVenueisSuccessfully } = useSelector(
    state => state.TicketVenueReducer
  )

  

//   useEffect(() => {
//   localStorage.removeItem("venue_id")
//   dispatch(fetchVenue(event_id_c?.EventId))
// }, [TicketVenueisSuccessfully])


useEffect(() => {
  if (event_id_c?.EventId) {
    dispatch(fetchVenue(event_id_c.EventId));
    console.log("Initial fetch");
  }

  localStorage.removeItem("venue_id");
}, []);

useEffect(() => {
  if (TicketVenueisSuccessfully) {
    console.log("Success triggered");

    dispatch(fetchVenue(event_id_c?.EventId));

    dispatch(resetVenue()); // ✅ REMOVE setTimeout
  }
}, [TicketVenueisSuccessfully]);

   function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()
  }

  // importance things to check venue publish or draft
  const isVenueComplete = venue => {
    if (!venue.venue || venue.venue.trim() === "") return false
    if (!venue.address || venue.address.trim() === "") return false
    if (!venue.start_datetime) return false
    if (!venue.end_datetime) return false
    if (!venue.max_tickets || venue.max_tickets <= 0) return false

    return true
  }
  const columns = useMemo(
    () => [
      {
        Header: "Venue",
        accessor: "venue",
        disableFilters: true,
      },
      // {
      //   Header: "Started on",
      //   accessor: "start_datetime",
      //   disableFilters: true,
      //   Cell: cellProps => {
      //     const sd = moment
      //       .utc(cellProps.row.original.start_datetime)
      //       .local()
      //       .format("YYYY-MM-DD hh:mm A")
      //     return (
      //       <ul className="list-unstyled">
      //         <p>{sd}</p>
      //       </ul>
      //     )
      //   },
      // },
      // {
      //   Header: "Ends on",
      //   accessor: "end_datetime",
      //   disableFilters: true,
      //   Cell: cellProps => {
      //     const sd = moment
      //       .utc(cellProps.row.original.end_datetime)
      //       .local()
      //       .format("YYYY-MM-DD hh:mm A")

      //     return (
      //       <ul className="list-unstyled">
      //         <p>{sd}</p>
      //       </ul>
      //     )
      //   },
      // },
      {
  Header: "Started on",
  accessor: "start_datetime",
  disableFilters: true,
  Cell: cellProps => {
    const sd = moment
      .utc(cellProps.row.original.start_datetime)   // DB is UTC
      // .tz("America/Chicago")                        // convert to Texas
      .local()
      .format("YYYY-MM-DD hh:mm A");

    return (
      <ul className="list-unstyled">
        <p>{sd}</p>
      </ul>
    );
  },
},
{
  Header: "Ends on",
  accessor: "end_datetime",
  disableFilters: true,
  Cell: cellProps => {
    const sd = moment
      .utc(cellProps.row.original.end_datetime)
      // .tz("America/Chicago")
      .local()
      .format("YYYY-MM-DD hh:mm A");

    return (
      <ul className="list-unstyled">
        <p>{sd}</p>
      </ul>
    );
  },
},

      {
        Header: "Max tickets",
        accessor: "max_tickets",
        disableFilters: true,
      },
          {
              Header: "Sold",
              accessor: "ticket_sold",
              disableFilters: true,
              Cell: cellProps => (
                <ul className="list-unstyled hstack gap-1 mb-0">
                  <li>
                    <div className="me-2">{cellProps.row.original.ticket_sold}</div>
                  </li>
                  <li>
                    <Link
                      to="/bookinghistory"
                      className="btn btn-sm btn-info"
                      onClick={e => {
                        const SData = cellProps.row.original
                        const PassingData = {
                          VenueName: SData.venue,
                          VenueId: SData._id,
                          MaxTicket: SData.max_tickets,
                        }
                        localStorage.setItem("venue_id", JSON.stringify(PassingData))
                      }}
                    >
                      Details
                    </Link>
                  </li>
                </ul>
              ),
            },

      // {
      //   Header: "Status",
      //   disableFilters: true,
      //   Cell: cellProps => {
      //     const SData = cellProps.row.original

      //     const isPublished = SData.publish_status === "published"

      //     const isComplete = isVenueComplete(SData)

      //     return (
      //       <Button
      //         size="sm"
      //         color={isPublished ? "success" : "warning"}
      //         disabled={!isComplete} // 👈 disable if incomplete
      //         title={!isComplete ? "Complete venue details first" : ""}
      //         onClick={() => {
      //           if (!isComplete) return

      //           const updatedStatus = isPublished ? "draft" : "published"

      //           const payload = {
      //             _id: SData._id,
      //             publish_status: updatedStatus,
      //             is_draft: updatedStatus === "draft",
      //           }

      //           dispatch(updateVenueStatus(payload))
      //           dispatch(fetchVenue(event_id_c?.EventId))
      //         }}
      //       >
      //         {isPublished ? "Published" : "Draft"}
      //       </Button>
      //     )
      //   },
      // },
      {
        Header: "Action",
        disableFilters: true,

        Cell: cellProps => {
          const SData = cellProps.row.original
          let sdbtncolor =
            SData.active_status === "Active"
              ? "btn-soft-danger"
              : "btn-soft-success"
          // console.log(sdbtncolor)
          return (
            <ul className="list-unstyled hstack  gap-1 mb-0">
              <li>
                <Link
                  // to="/ticketvenue"
                  className="btn btn-sm btn-soft-info"
                  // style={new Date(SData.end_datetime) < new Date() ? { pointerEvents: 'none', backgroundColor: "#dddddd" } : {}}

          
                  onClick={e => {
                  e.preventDefault() 
  e.stopPropagation(); 
                  const PassingData = {
                    VenueName: SData.venue,
                    VenueId: SData._id,
                    MaxTicket: SData.max_tickets,
                  }

                  localStorage.setItem("venue_id", JSON.stringify(PassingData))
                  localStorage.setItem("editUser", JSON.stringify(SData))
                  localStorage.setItem("venueDraftId", SData._id)

                  // dispatch(editUser(SData))

                  navigate("/ticketvenue") // ✅ single navigation
                }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={e => {
                    e.preventDefault()
                    const SData = cellProps.row.original
                    // console.log("deleteID", SData._id)
                    tog_backdrop()
                    SetDelete_data({ _id: SData._id })
                    return false
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li></li>
            </ul>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Ticket Venues" breadcrumbItem="Ticket Venues" />
          <Row className="justify-content-center">
            <Card>
              <CardBody className="border-botton">
                <div className="d-flex align-items-center ">
                  <h5 className="mb-1 card-title flex-grow-1 text-primary">
                    {event_id_c.EventName}
                  </h5>
                  <div className="mb-1 flex-shrink-0">
                    
                    <Link
                      to="#"
                      className="btn btn-primary me-1"
                      onClick={e => {
                        e.preventDefault()
                        localStorage.removeItem("venueDraftId")
                        localStorage.removeItem("editUser")
                        navigate("/ticketvenue")
                      }}
                    >
                      Add Venue
                    </Link>
                    <Link
                      to="#!"
                      className="btn btn-secondary me-1"
                      onClick={e => {
                        e.preventDefault()
                        navigate("/ticketeventlist")
                      }}
                    >
                      Back
                    </Link>
                    <Link
                      to="#!"
                      onClick={() => {
                        dispatch(fetchVenue(event_id_c?.EventId))
                      }}
                      className="btn btn-light me-1"
                    >
                      <i className="mdi mdi-refresh"></i>
                    </Link>
                  </div>
                </div>
                <Row>
                  <div className="container-fluid">
                    <TableContainer
                      columns={columns}
                      data={TicketVenueList}
                      isGlobalFilter={true}
                      isAddOptions={false}
                      customPageSize={20}
                      isJobListGlobalFilter={false}
                      isColumnFilterEnabled={false}
                      // className="custom-header-css"
                    />
                  </div>
                </Row>
                {TicketVenueList.length > 10 ? (
                  <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <Link to="#" className="text-success">
                          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                          Load more
                        </Link>
                      </div>
                    </Col>
                  </Row>
                ) : null}
              </CardBody>
            </Card>
          </Row>
          {/*delete Modal */}
          <Modal
            isOpen={modal_backdrop}
            toggle={() => {
              tog_backdrop()
            }}
            backdrop={"static"}
            id="staticBackdrop"
          >
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Delete
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setmodal_backdrop(false)
                }}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body font-size-15">
              <p>Are you sure, you want to delete?</p>
            </div>
            <div className="modal-footer ">
              <button
                type="button"
                className="btn btn-danger me-2"
                onClick={() => {
                  dispatch(deleteVenue(delete_data))
                  setmodal_backdrop(false)
                 }}
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setmodal_backdrop(false)
                }}
              >
                No
              </button>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VenueTicketList
